import { ObjectPropertyType } from "../ObjectPropertyType";
import { VariableScope } from './VariableScope';


export class ChildVariableScope extends VariableScope {
	constructor(parentScope: VariableScope, additionalVariable: ObjectPropertyType) {
		super(new Map([[additionalVariable.name, additionalVariable]]));
		this.addPrevious(parentScope);
	}
}
